import React, { useEffect } from "react";
import confetti from "canvas-confetti";
import { useRecoilValue } from "recoil";
// atoms
import confettiEffectAtom from "src/recoil/atoms/confettiEffectAtom";

const FullScreenConfetti = () => {
  const isTriggered = useRecoilValue(confettiEffectAtom);

  useEffect(() => {
    if (isTriggered) {
      const duration = 8 * 1000; // Change the duration to 5 seconds
      const animationEnd = Date.now() + duration;
      const defaults = {
        startVelocity: 30,
        spread: 560,
        ticks: 60,
        zIndex: 1000000000,
        scalar: 2, // Increase the particle size by setting the scalar value
        shape: ["circle", "circle", "square"], // Set the shape to square
      };

      const interval = setInterval(() => {
        const timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
          return clearInterval(interval);
        }

        const particleCount = 50 * (timeLeft / duration);
        confetti({
          ...defaults,
          particleCount,
          origin: { x: Math.random(), y: Math.random() - 0.2 },
        });
      }, 250);
    }
  }, [isTriggered]);

  return null;
};

export default FullScreenConfetti;
